"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlyIf = void 0;
const widget_1 = require("../basics/widget");
const onlyIf = (condition, widget) => condition ? widget : (0, widget_1.nothing)();
exports.onlyIf = onlyIf;
